import { createReducer, on } from '@ngrx/store';
import {
  deleteServices,
  getFieldsForTable,
  getServices,
  getServicesOrder,
  saveServices,
  setFields,
  setFieldsForTable,
  setServices,
  setServicesOrder,
  updateServicesOrder,
  setTotRecs,
  getServicesBasedOnSearch,
  getParentFields,
  setParentFields,
  setServicesByAppId
} from '../actions/services.actions';

export interface ServicesState {
  data: any;
}

export const initialState: ServicesState = {
  data: {}
};

export const servicesReducer = createReducer(
  initialState,
  on(getServices, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants
  })),
  on(getServicesBasedOnSearch, (state, { searchApiConstants, searchFields }) => ({
    ...state,
    ...searchApiConstants,
    searchFields
  })),
  on(setServices, (state, { servicesTable }) => ({
    ...state,
    ...{ servicesTable }
  })),
  on(setServicesByAppId, (state, { servicesByAppId }) => ({
    ...state,
    ...{ servicesByAppId }
  })),
  on(setTotRecs, (state, { totalServRecords }) => ({
    ...state,
    ...{ totalServRecords }
  })),
  on(saveServices, (state, { servicesData }) => ({
    ...state,
    ...servicesData
  })),
  on(updateServicesOrder, (state, { servicesOrderData }) => {
    return {
      ...state,
      ...servicesOrderData
    };
  }),
  on(deleteServices, (state, { serviceIds }) => {
    return {
      ...state,
      serviceIds
    };
  }),
  on(getServicesOrder, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants
  })),
  on(setServicesOrder, (state, { servicesOrder }) => ({
    ...state,
    ...{ servicesOrder }
  })),
  on(setFields, (state, { fields }) => ({
    ...state,
    ...{ fields }
  })),
  on(getFieldsForTable, (state, { fstAPiConstants, params }) => ({
    ...state,
    ...{ fstAPiConstants },
    ...{ params }
  })),
  on(setFieldsForTable, (state, { tblFields }) => ({
    ...state,
    ...{ tblFields }
  })),
  on(getParentFields, (state, { parentAPiConstants, params }) => ({
    ...state,
    ...{ parentAPiConstants },
    ...{ params }
  })),
  on(setParentFields, (state, { parentFields }) => ({
    ...state,
    ...{ parentFields }
  }))
);
